<div class="item-choice" [ngClass]="{'has-all-controls': stepItem.availableSizePrices?.length > 1 &&
  stepItem.itemWithIngredientChoices && !stepItem.itemWithRequiredIngredientChoices}">
  <select *ngIf="stepItem.availableSizePrices?.length > 1"
          [(ngModel)]="stepItem.selectedSize"
          name="size"
          (ngModelChange)='sizeSelected.emit($event)'
          [disabled]='!!currentStep?.selectedOrderableItem'
          class="form-control primary-bg-color primary-text-color item-size-options sizeInput"
          [attr.aria-label]="'component.item_choice.size_options' | translate">
    <option disabled [ngValue]='undefined'>{{'component.item_choice.select_size' | translate}}</option>
    <option *ngFor='let sizePrice of stepItem.availableSizePrices' [ngValue]='sizePrice.size'>
      {{sizePrice.label}}
      <ng-container *ngIf='sizePrice.servings'>({{orderableItemService.getServings(sizePrice)}})</ng-container>
    </option>
  </select>

  <div class="buttons-container">
    <button *ngIf="stepItem.itemWithIngredientChoices"
            #cBtnRef
            ftsAsyncButton
            [subscription]="customizeItemLoadingSubscription"
            [disabled]="isCustomizeDisabled"
            class="btn fw-600 text-center btn-block primary-bg-color selection-border-color selection-text-color selection-btn font-secondary customize-btn text-uppercase"
            [class.bg-transparent]="isCustomizeDisabled"
            [class.primary-text-color]="isCustomizeDisabled"
            [class.primary-text-border-color]="isCustomizeDisabled"
            (click)='customizeItem()'>
      {{(!stepItem.availableSizePrices.length ? 'component.item_choice.not_available' : 'component.item_choice.customize') | translate}}
    </button>

    <button ftsAsyncButton [subscription]="selectItemLoadingSubscription"
            #sBtnRef
            *ngIf="!!stepItem?.availableSizePrices?.length && !stepItem.itemWithRequiredIngredientChoices && (!currentStep?.selectedOrderableItem || !currentStep?.isSelectedAlternativeItem(stepItem))"
            [disabled]="isOrderDisabled"
            class="btn fw-600 order-btn selection-bg-color selection-inverse-text-color shadowed primary-btn selection-btn font-secondary text-uppercase"
            [class.bg-transparent]="isOrderDisabled"
            [class.primary-text-color]="isOrderDisabled"
            (click)="selectItem()">
      {{'component.item_choice.order' | translate}}
    </button>

    <button *ngIf="currentStep?.selectedOrderableItem && currentStep?.isSelectedAlternativeItem(stepItem)"
            class="btn fw-600 remove-btn primary-text-color primary-text-border-color text-muted primary-btn shadowed font-secondary text-uppercase" (click)="removeItem()">{{'component.item_choice.remove' | translate}}</button>
  </div>
</div>
